/**
 * TODO: Unify approach for Date untils
 * Move to use Moment everywhere as we currently have a mix of Moment and javascript Date
 */
import moment from 'moment';

/**
 * Moment function to format a given date/time
 */
export function formatDateTime(value, format) {
  return moment(value).format(format);
}

/**
 * Moment function to display time since a given date eg:
 * - 12 years ago
 * - a few seconds ago
 */
export function formatFromNow(value) {
  return moment(value).fromNow();
}

/**
 * formatAsDateString formats a Date object like '2020-01-01'
 *
 * @param {Date} date - The Date object to format
 * @returns {string} The formatted date string
 */

export function formatAsDateString(date) {
  if (!(date instanceof Date)) {
    throw new Error('Must provide a Date object');
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * daysToMilliseconds converts a number of days to milliseconds
 *
 * @param {number} days - The number of days to convert
 * @returns {number} The number of milliseconds
 */

export function daysToMilliseconds(days) {
  if (typeof days !== 'number') {
    throw new Error('Must provide a number of days');
  }
  return days * 24 * 60 * 60 * 1000;
}

/**
 * subDays subtracts a number of days from a Date object and returns the
 * resulting Date object.
 *
 * @param {Date} date - The Date object to subtract from
 * @param {number} days - The number of days to subtract
 * @returns {Date} The resulting Date object
 */

export function subDays(date, days) {
  if (!(date instanceof Date)) {
    throw new Error('Must provide a Date object');
  }
  const output = new Date();
  output.setTime(date.getTime() - daysToMilliseconds(days));
  return output;
}

/**
 * differenceInDays returns the absolute difference in days between two Date
 * objects.
 *
 * @param {Date} dateLeft - The first Date to compare
 * @param {Date} dateRight - The second Date to compare
 * @returns {number} The difference in days
 */

export function differenceInDays(dateLeft, dateRight) {
  if (!(dateLeft instanceof Date) || !(dateRight instanceof Date)) {
    throw new Error('Must provide Date objects');
  }
  const differenceInMs = Math.abs(dateLeft.getTime() - dateRight.getTime());
  return Math.round(differenceInMs / daysToMilliseconds(1));
}

/**
 * makeDefaultDateRange constructs a date range of 30 days and returns
 * a tuple of the start and end date strings.
 *
 * @returns {string[]} ie. ['2020-01-01', '2020-02-01']
 *
 */

export function makeDefaultDateRange() {
  const today = new Date();
  const startDateStr = formatAsDateString(subDays(today, 30));
  const endDateStr = formatAsDateString(today);
  return [startDateStr, endDateStr];
}
